import React, { ReactElement } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

//Components
import UpdateWghtRecordForm from './UpdateWghtRecordForm';

// Interfaces
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { WeightAlertGroupRecord } from '../Interfaces/Alerts/AlertRecord';

// Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogTitle: {
      textAlign: 'center',
      fontSize: '1.5rem',
      color: '#23496B',
      fontWeight: 'bold',
    },
    box: {
      height: 60,
      display: 'flex',
      padding: theme.spacing(2),
      margin: theme.spacing(1),
    },
    spreadBox: {
      justifyContent: 'space-around',
      alignItems: 'center',
    },
    dialogAction: {
      height: '3rem',
      padding: theme.spacing(3),
    },
  })
);

interface Props {
  title: string;
  isDialogOpened: boolean;
  handleCloseDialog: (open: boolean) => void;
  alertToUpdate: WeightAlertGroupRecord;
}

const UpdateWghtDialog: React.FC<Props> = ({
  title,
  isDialogOpened,
  handleCloseDialog,
  alertToUpdate,
}): ReactElement => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();

  const handleClose = () => {
    handleCloseDialog(false);
  };

  return (
    <Dialog open={isDialogOpened} onClose={handleClose}>
      <DialogTitle className={classes.dialogTitle} disableTypography>
        {title}
      </DialogTitle>
      <DialogContent dividers>
        <UpdateWghtRecordForm
          alert={alertToUpdate}
          closeContainer={handleClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default UpdateWghtDialog;
